/**
 * Theme-wide Swiper defaults. Loaded with `defer` straight after the Swiper
 * library in layout/theme.liquid, so it runs before any carousel script
 * initialises a slider; a slider's own options still override these.
 *
 * Swiper's stock 300ms transition is short enough that the first slide, while
 * the newly revealed cards paint, loses most of its frames and reads as a jump
 * rather than a slide. 600ms keeps the movement visible on arrows, dots and
 * swipes alike.
 */
if (window.Swiper) {
  window.Swiper.extendDefaults({
    speed: 600,
  });

  /**
   * Swiper's A11y module makes every .swiper-wrapper an aria-live="polite"
   * region. Anything that changes inside a slide (a lazy image loading, a
   * review widget rendering, a video's play state) is then read out by iOS
   * VoiceOver while the user is elsewhere on the page, and can't be silenced
   * with the two-finger tap. Slides are read as the user swipes to them, so
   * the region is switched off. Registered as a module so it runs after A11y's
   * own afterInit on every slider, whatever options the slider passes.
   */
  window.Swiper.use(function SwiperNoLiveRegion({ swiper, on }) {
    on('afterInit', () => {
      swiper.wrapperEl?.setAttribute('aria-live', 'off');
    });
  });
}
